function padLeftZero(num) {
  return num < 10 ? `0${num}` : `${num}`;
}

export function formatDate(d) {
  return `${padLeftZero(d.getDate())}/${padLeftZero(
    d.getMonth()
  )}/${padLeftZero(d.getFullYear())} ${padLeftZero(d.getHours())}:${padLeftZero(
    d.getMinutes()
  )}:${padLeftZero(d.getSeconds())}`;
}
